<template>
    <div :class="containerClass + ' ' + imgClass">
        <a @click.prevent="avatarClicked" href="" v-if="(memberId||full) && !publicView">
            <img :height="size+15" :title="name" alt="avatar image"
                 v-if="avatar"
                 class="rounded-circle z-depth-1-half" v-bind:src="avatar"/>
        </a>
        <img :aria-label="name" :height="size+15" :title="name"
             alt="avatar image" class="rounded-circle z-depth-1-half"
             v-bind:src="avatar" v-if="avatar && (!memberId || publicView)"/>

        <mdb-badge :color="badgeColor" class="image-badge" v-if="badge">{{badge}}</mdb-badge>
        <member-modal :id="modalId" @modalClosed="modalId=null"/>
    </div>
</template>

<script>
import {mdbBadge} from 'mdbvue';
import MemberModal from "../group/MemberModal";

export default {
        name: 'Avatar',
        components: {
            mdbBadge,
            MemberModal
        },
        data() {
            return {
                modalId: null
            }
        },
        /*beforeMount() {
            if (this.reputation) {
                this.imgClass = " reputation-" + this.reputation
            }
        },*/
        props: {
            avatar: {
                type: String,
                default: null
            },
            memberId: {
                type: Number,
                default: null
            },
            groupId: {
                type: Number,
                default: null
            },
            reputation: {
                type: String,
                default: null
            },
            size: {
                type: Number,
                default: 65
            },
            badge: {
                type: String,
                default: null
            },
            containerClass: {
                type: String,
                default: "avatar-container"
            },
            name: {
                type: String,
                default: ""
            },
            badgeColor: {
                type: String,
                default: "secondary-color"
            },
            full: {
                type: String,
                default: null
            },
            publicView: {
                type: Boolean,
                default: false
            }
        },
        computed: {
          imgClass() {
            if (this.reputation) return " reputation-" + this.reputation
            else return ""
          }
        },
        methods: {
            avatarClicked() {
                if (this.memberId) this.modalId = this.memberId
                else {
                    if (this.full) {
                        window.open(this.full)
                    }
                }
            }
        }
    };
</script>

<style scoped>
    .avatar-container {
        float: left;
        padding-right: 10px
    }

    .reputation-gold img {
        border: 5px solid gold;
    }

    .reputation-bronze img {
        border: 5px solid #cd7f32;
    }

    .reputation-green img {
        border: 5px solid #006400;
    }

    .reputation-silver img {
        border: 5px solid #c0c0c0;
    }

    .reputation-red img {
        border: 5px solid #8d283d;
    }

    .reputation-empty img {
        border: 5px solid #f0f1f0;
    }

    .image-badge {
        margin-left: -15px;

    }

    .avatar-right {
        float: right;
    }

</style>
